"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var processRequest_1 = require("./processRequest");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return processRequest_1.default; } });
//# sourceMappingURL=index.js.map